import { render } from "./ProjectIndex.vue?vue&type=template&id=ff5a3bd0"
import script from "./ProjectIndex.vue?vue&type=script&lang=js"
export * from "./ProjectIndex.vue?vue&type=script&lang=js"
script.render = render

export default script